// extracted by mini-css-extract-plugin
export default {"wide-page-wrapper":"WidePageWrapper_wide-page-wrapper__xB5iP","widePageWrapper":"WidePageWrapper_wide-page-wrapper__xB5iP"};